/* eslint-disable */
import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon'

const FrenchTableIcon = props => (
  <SvgIcon {...props}>
    <path d="M7,19 C4.790861,19 3,17.209139 3,15 C3,12.790861 4.790861,11 7,11 C9.209139,11 11,12.790861 11,15 C11,17.209139 9.209139,19 7,19 Z M12,11 C9.790861,11 8,9.209139 8,7 C8,4.790861 9.790861,3 12,3 C14.209139,3 16,4.790861 16,7 C16,9.209139 14.209139,11 12,11 Z M17,19 C14.790861,19 13,17.209139 13,15 C13,12.790861 14.790861,11 17,11 C19.209139,11 21,12.790861 21,15 C21,17.209139 19.209139,19 17,19 Z" />
  </SvgIcon>
)

export default FrenchTableIcon



// WEBPACK FOOTER //
// ./src/components/FrenchTableIcon.js